import React from 'react'
import { APP_PREFIX_PATH } from 'configs/AppConfig';

export class RuoliProtectedRoute {

    static ruoli = [
        {
            key: 'gestisci-utenti',
            path: `${APP_PREFIX_PATH}/ruoli/gestisci-utenti`,
            component: React.lazy(() => import('views/app-amministrazione-views/ruoli/gestisci-utenti')),
        },
        {
            key: 'gestisci-punti',
            path: `${APP_PREFIX_PATH}/ruoli/gestisci-punti`,
            component: React.lazy(() => import('views/app-amministrazione-views/ruoli/gestisci-punti')),
        },
        {
            key: 'gestisci-aziende',
            path: `${APP_PREFIX_PATH}/ruoli/gestisci-aziende`,
            component: React.lazy(() => import('views/app-amministrazione-views/ruoli/gestisci-aziende')),
        },
    ];

    static getNavTree() {
        return this.ruoli;
    }

}

export default RuoliProtectedRoute;
